import { combineReducers } from "redux";
import ETReducer from "./ETReducer";
import commonReducer from "./commonreducer";
export default combineReducers({
  ETState: ETReducer,
  CState: commonReducer,
});
